<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({        
        head: {
			title: { inner: 'Find a Tennis Hit', separator: '|', complement: 'Str8 Sets Matcha' },
            meta: [
				{ name: 'description', content: 'Finding a hit of tennis at your skill level is easy. Matcha is a unique skill-based ranking system that allows you to meet people at your level. Download Str8 Sets to your device and find a hit of tennis today.', id: 'desc'},
                { property: 'og:type', content: 'website' },
				{ property: 'og:url', content: 'https://www.str8sets.com/tennis_find_a_hit_matcha' },
                { property: 'og:title', content: 'Find a Tennis Hit | Str8 Sets Matcha' },
                { property: 'og:description', content: 'Finding a hit of tennis at your skill level is easy. Matcha is a unique skill-based ranking system that allows you to meet people at your level. Download Str8 Sets to your device and find a hit of tennis today.' },
                { property: 'og:image', content: 'https://www.str8sets.com/img/meta_str8sets_tennis_matcha_1200x628.jpg' },   
				{ property: 'og:image:alt', content: 'Str8 Sets Tennis Logo and Matcha Screenshots' },            
                { name: 'twitter:site', content: 'str8sets' },
				{ name: 'twitter:creator', content: '@str8sets' },
				{ name: 'twitter:card', content: 'summary_large_image' },  
				{ name: 'twitter:url', content: 'https://www.str8sets.com/tennis_find_a_hit_matcha' },
				{ name: 'twitter:title', content: 'Find a Tennis Hit | Str8 Sets Matcha' },
                { name: 'twitter:description', content: 'Finding a hit of tennis at your skill level is easy. Matcha is a unique skill-based ranking system that allows you to meet people at your level. Download Str8 Sets to your device and find a hit of tennis today.' },
				{ name: 'twitter:image', content: 'https://www.str8sets.com/img/meta_str8sets_tennis_matcha_1200x628.jpg' },
				{ name: 'twitter:image:alt', content: 'Str8 Sets Tennis Logo and Matcha Screenshots' }
            ],
            link: [
      			{ rel: 'canonical', href: 'https://www.str8sets.com/tennis_find_a_hit_matcha', id: 'canonical' }
			]
        }
    })
</script>

<template>

    <div>    

        <div class="parallax image-balls-blue-court height-350">
            <div class="container">
                <div class="feature-page-header">
                    <h1>Matcha</h1>
                    <h2>Find a hit when you want, where you want</h2>
                </div>
                <div class="row">
                    <router-link class="clear_button" to="/faq#matcha">FREQUENT QUESTIONS</router-link>
                </div>
            </div>
        </div> 

        <section class="feature-list section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <p>We love the idea of <strong>enabling you to get the best out of yourself</strong>. If you want to improve your game you 
                                already know that you need to test yourself against many different players instead of 
                                playing the same person every week, winning easily, losing easily or even having a tight match. You 
                                want to test yourself against different styles, learn how to adjust and get the best out of yourself.</p> 
                                <p>Matcha allows you to do just that!</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="spacer-large"></div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12 heading">
                        <img class="icon" src="@/assets/images/matcha.svg" alt="Green Matcha Icon" data-no-retina>
                        <h2>How does Matcha work?</h2>
                        <h4>Find a hit at your skill level</h4>
                    </div>                            
                </div>
                <div class="row">                               
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <p>Matcha is a <strong>unique skill-based ranking system</strong> that allows you to meet people at your level and enables 
                                you to play when and where you want.</p>
                            <p>Setup Matcha on the Str8 Sets app to get your initial skill level. Following that every time you enter 
                            a new match against another Matcha-ranked player, it adjusts your points based on your opponent’s level 
                            and the score of the match. But remember, for this to happen, the match needs to be approved by your 
                            opponent, or it needs to have taken place in a Str8 Sets organised competition.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="spacer-large"></div>
            <div class="container">
                <div class="row text-center">
                    <img class="img_inrow" :src="'/img/iphone_matchalevels_243x440.jpg'" alt="Str8 Sets App Screenshot (iPhone, Matcha Levels)" v-rjs="2">
                    <img class="img_inrow" :src="'/img/iphone_matchaaddhit_243x440.jpg'" alt="Str8 Sets App Screenshot (iPhone, Matcha Request Hit)" v-rjs="2">
                    <img class="img_inrow" :src="'/img/iphone_matchahome_243x440.jpg'" alt="Str8 Sets App Screenshot (iPhone, Matcha Home)" v-rjs="2">
                </div> 
            </div>
        </section>

        <div class="parallax image-balls-blue-court height-150" ></div>

        <section class="feature-list section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <div class="text-heading">
                                <h2>Age and Gender agnostic</h2>
                            </div> 
                            <p><strong>Matcha is age and gender agnostic</strong>. It doesn't matter if you're 15 or 70, man or woman, all you need to 
                            do is find someone at your level. But if you have your age and gender preferences for opponents, you can 
                            specify those preferences in the Matcha settings. Your hit requests will be shown to people who 
                            fit your criteria.</p>
                        </div>
                    </div>
                </div>
                <div class="spacer-large"></div>
                <div class="card">
                    <div class="row">
                        <div class="col-md-12">
                            <img class="icon" src="@/assets/images/club.svg" alt="Green Club Icon" data-no-retina>
                            <h2>Matcha for Clubs</h2>                                    
                        </div> 
                    </div>
                    <div class="spacer"></div>
                    <div class="row">
                        <div class="col-md-12">
                            <p>Matcha will increase player engagement in your club, get your members to meet each other and strengthen your club culture in general. It will also allow 
                                new members to feel more comfortable and meet people easily. This can only lead to good things for your club and increase your members' loyalty.</p>
                            <p>If you purchase Matcha for your club, you'll be in control of its use within the club. For example, you can limit it to your members only, or you can 
                                allow non-members to accept hit requests by your members. You can also allow non-members to request hits in your club. You can set those preferences 
                                or change them anytime with immediate effect from the club management portal on the website. </p>
                            <p>Matcha is available as part of the club's Gold or Platinum tier, which is paid on a per-member per annum basis.</p>
                        </div> 
                    </div>
                </div>
                <div class="spacer-large"></div>
                <div class="card">
                    <div class="row">
                        <div class="col-md-12">
                            <img class="icon" src="@/assets/images/player.svg" alt="Green Player Icon" data-no-retina>
                            <h2>Matcha for Players</h2>                                    
                        </div> 
                    </div>
                    <div class="spacer"></div>
                    <div class="row">
                        <div class="col-md-12">
                            <p>When you first use Str8 Sets, you will be offered 2 hits free of charge to try out Matcha. After that, you can get Matcha if it was purchased by your 
                                club for all members, or you can buy it individually as part of Str8 Sets' premium in-app purchases.</p>
                        </div> 
                    </div>
                </div>
            </div>
        </section>

        <div class="parallax image-balls-blue-court height-150" ></div>
    </div>
</template>